import _ from "underscore";
import baustein from "baustein";
import analytics from "web/script/analytics/analytics";

export default baustein.register("tracked-form", {
    tagName: "form",

    defaultOptions: {
        eventCategory: null,
        eventAction: null,
        eventLabel: null,
    },

    setupEvents: function(add) {
        add("submit", this.onSubmit);
    },

    onSubmit: function(event) {
        var category = this.options.eventCategory;
        var action = this.options.eventAction;
        var label = this.options.eventLabel;

        if (!_.isString(category) || !_.isString(action)) {
            return;
        }

        event.preventDefault();

        this.emit("trackedFormSubmit");

        analytics.event(category, action, label).then(
            function() {
                this.el.submit();
            }.bind(this)
        );
    },
});
